import { createAction } from '../../utils/createAction';

import { ILayoutRestoreAction, LAYOUT_RESTORE } from './layout.types';

export const restoreLayout = createAction<ILayoutRestoreAction>(LAYOUT_RESTORE);
